import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";

import CardBody from "beaktShared/components/Card/CardBody.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import InputAdornment from '@material-ui/core/InputAdornment';
import LoadingIcon from "@material-ui/icons/Cached";
import "beaktShared/components/CustomInput/rotate.css";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import { SessionContext, getSessionCookie } from "beaktShared/services/session";
import Select from 'react-select';
import CircularProgress from '@material-ui/core/CircularProgress';
import Autocomplete from '@material-ui/lab/Autocomplete';

// services
import { MaskDate, formateDate, validateDate, convertDate, MaskTime, MaskCPF, MaskCel } from "beaktShared/helpers/masks";
import { UsePostApi, UseGetApiSimple } from "beaktShared/services/crudeApiService";

// style
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { isJSDocReturnTag } from "typescript";
const useStyles = makeStyles(styles);

export default function NovoAgendamento({ prof, serv, selectedSlot, closemodalAdd, setnewevent, selectedServico, obs }) {
    const { t } = useTranslation();
    const classes = useStyles();
    const [session, setSession] = React.useState(useContext(SessionContext));

    const { register, handleSubmit, setValue, getValues, errors, clearError, setError } = useForm({ mode: "onChange" });
    const [profissional, setprofissional] = React.useState("");
    const [listSelectProfissional, setlistSelectProfissional] = React.useState([]);
    const [servico, setservico] = React.useState("");
    const [allservico, setallservico] = React.useState("");
    const [listSelectServico, setlistSelectServico] = React.useState([]);
    
    const [loading, setLoading] = React.useState(false);
    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const [celularObrigatorio, setCelularObrigatorio] = React.useState(false);
    
    const showNotification = (mensagem, color) => {
        setMensagemNotification(mensagem);
        setColorNotification(color);
        setNotification(true);
        setTimeout(function () {
            setNotification(false);
        }, 6000);
    };

    useEffect(() => {
        handleSetup();
        setlistSelectProfissional(prof);
        setSession(getSessionCookie());
    }, [prof]);

    useEffect(() => {
        handleSetup();
        setlistSelectServico(serv);
        setallservico(serv);
        
        if (!(selectedServico === null)) {
            var vefifyExists = serv.filter(obj => {
                return obj.descricao === selectedServico;
            });
            if (vefifyExists[0]) {
                handleServicoChange(vefifyExists[0].servicoId);
                if (vefifyExists.length > 0)
                    setValue("duracao", vefifyExists[0].tempoExecucao);
                else
                    setValue("duracao", "");
            }
        }
        if (!(obs === null)) {
            setValue("obs", obs);
        }
    }, [serv]);

    useEffect(() => {
        handleSetup();

        if (!selectedSlot)
            return;

        var dateComplete = new Date(selectedSlot.start);

        var month = dateComplete.getMonth() + 1;
        if (month <= 9)
            month = "0" + month;
        var day = dateComplete.getDate();
        if (day <= 9)
            day = "0" + day;
        var year = dateComplete.getFullYear();

        var hours = dateComplete.getHours();
        var minutes = dateComplete.getMinutes();
        if (hours <= 9)
            hours = "0" + hours;
        if (minutes <= 9)
            minutes = "0" + minutes;

        var date = day + "/" + month + "/" + year;
        var time = hours + ":" + minutes;

        setValue("data", date);
        setValue("hora", time);

        if (selectedSlot.resourceId) {
            setValue("profissional", selectedSlot.resourceId);
            setprofissional(selectedSlot.resourceId);

            loadServicosbyProfissional(selectedSlot.resourceId)
        }

        setValue("nomecliente", "");
        setValue("emailcliente", "");
        setValue("cpfcliente", "");
        setValue("celularcliente", "");

        setdisabledEmail(false);
        setdisabledNome(false);
        setdisabledCPF(false);
        setdisabledCelular(false);

        if (obs === null || obs === "")
            setValue("obs", "");

    }, [selectedSlot]);

    const loadServicosbyProfissional = (idprofissional) => {

        var profissionalSelecionado = prof.filter(obj => {
            return obj.id === idprofissional;
        });

        if (profissionalSelecionado[0].servicos === null)
            return;

        var idsServicos = [];
        profissionalSelecionado[0].servicos.map(item => {
            idsServicos.push(item.servicoId);
            return true;
        })

        var servicoFiltered = [];
        idsServicos.map(id => {

            var servicobyProfissional = allservico.filter(obj => {
                return obj.servicoId === id;
            });
            if (servicobyProfissional !== null)
                servicoFiltered.push(...servicobyProfissional);

        })

        setlistSelectServico(servicoFiltered);

    }

    const intialValues = {
        cliente: '',
        profissional: '',
        servico: '',
        idcliente: 0
    };

    const handleProfissionalChange = event => {
        let value = event
        setprofissional(value);
        setValue("profissional", value);
        loadServicosbyProfissional(value)
        if (value !== "")
            clearError("profissional");

        setservico(null);
        setValue("servico", null);
    };

    const handleServicoChange = event => {
        let value = event
        setservico(value);
        setValue("servico", value);
        if (value !== "")
            clearError("servico");

        var vefifyExists = listSelectServico.filter(obj => {
            return obj.servicoId === value;
        });

        if (vefifyExists.length > 0)
            setValue("duracao", vefifyExists[0].tempoExecucao);
        else
            setValue("duracao", "");

    };

    const hideModal = () => {
        closemodalAdd();
        setdisabledEmail(false);
        setdisabledNome(false);
        setdisabledCPF(false);
        setdisabledCelular(false);
    }

    const [loadingValidateEmail, setloadingValidateEmail] = React.useState(false);
    const [disabledEmail, setdisabledEmail] = React.useState(false);
    const [disabledNome, setdisabledNome] = React.useState(false);
    const [disabledCPF, setdisabledCPF] = React.useState(false);
    const [disabledCelular, setdisabledCelular] = React.useState(false);

    const handleEmailChange = e => {
        let email = e.target.value;
        if (email === "")
            return;

        setloadingValidateEmail(true);
        const endPoint = "clientes/clientebyemailvenda/" + email + "/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
            if (result.status === 500) {
                showNotification(result.message, 'danger')
                setloadingValidateEmail(false);
                return false;
            }

            var values = getValues();
            if (result.status !== 200) {
                if (values.cpfcliente === "") {
                    setValue("idcliente", 0)
                    setValue("nomecliente", "");
                }
                setloadingValidateEmail(false);
                return false;
            }
            if (result.data) {
                setValue("idcliente", result.data.clienteId);
                setValue("nomecliente", result.data.nome);
                setValue("cpfcliente", result.data.cpf);
                setValue("celularcliente", result.data.celular);
                
                if (result.data.cpf != "" && result.data.cpf != null) {
                    //setdisabledCPF(true);
                }
                else {
                    //setdisabledCPF(false);
                }
                setdisabledNome(true);
            }
            setloadingValidateEmail(false);
            return true;
        });
    }

    const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);
    const handleCPFChange = e => {
        let cpf = e.target.value;
        if (cpf === "")
            return;
        if (cpf.length < 14)
            return;

        setloadingValidateCPF(true);
        const endPoint = "clientes/clientebycpfvenda/" + cpf + "/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint, 0).then(result => {
            // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
            if (result.status === 500) {
                showNotification(result.message, 'danger')
                setloadingValidateCPF(false);
                return false;
            }
            if (result.status !== 200) {
                setValue("idcliente", 0);
                setValue("nomecliente", "");
                setValue("emailcliente", "");
                setValue("celularcliente", "");
                setloadingValidateCPF(false);
                setdisabledEmail(false);
                setdisabledNome(false);
                return false;
            }
            if (result.data) {
                setValue("idcliente", result.data.clienteId);
                setValue("nomecliente", result.data.nome);
                setValue("emailcliente", result.data.email);
                setValue("celularcliente", result.data.celular);

                if (result.data.email != "" && result.data.email != null) {
                    setdisabledEmail(true);
                }
                else {
                    setdisabledEmail(false);
                }
                setdisabledNome(true);
            }
            setloadingValidateCPF(false);
        });
    }
    
    const onSubmit = data => {

        if (!validateDate(data.data)) {
            return setError("data", "invaliddate", t('error_message.invalid_date'))
        }

        var dataC = convertDate(data.data);

        var obj = {
            agendamentoId: 0,
            data: dataC,
            horaInicio: data.hora,
            horaFim: "00:00:00",
            tempoDuracao: parseInt(data.duracao),
            servicoId: data.servico,
            clienteId: parseInt(data.idcliente),
            cpfcliente: data.cpfcliente,
            emailcliente: data.emailcliente,
            nomecliente: data.nomecliente,
            celularcliente: data.celularcliente,
            profissionalId: data.profissional,
            obs: data.obs,
            statusAgendamento: 0,
            usuarioCadastroId: session.id,
            estabelecimentoId: session.estabelecimentoId
        }
        
        let endPoint = 'agendamentos/';
        setLoading(true);
        UsePostApi(endPoint, obj).then(result => {
            if (result.status !== 201) {
                showNotification(result.message.message, 'danger');
                setLoading(false);
                return false;
            }

            setnewevent(result.data);
            setLoading(false);
            closemodalAdd();
            setValue("", "");
            return true;
        });
    };

    const handleSetup = () => {
        const endPoint = "agendamentos/getSetupEstabelecimento/" + session.estabelecimentoId;
        UseGetApiSimple(endPoint,0).then(result=>{
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                return false; 
            }  

            let lstSetup = [];
            result.data.map(item => lstSetup.push({
                setupEstabelecimentoId: item.setupEstabelecimentoId,
                estabelecimentoId: item.estabelecimentoId,
                setupId: item.setupId,
                ativo: item.ativo,
                descricao: item.setup.descricao,
                codigo: item.setup.codigo
            }));
            
            const setupCelularObrigatorio = lstSetup.some(
                setup => setup.codigo === "SETUP04" && setup.ativo === true
            );
            setCelularObrigatorio(setupCelularObrigatorio);
        });

        setPesquisaPor("NOME");
    }

    const onlyNumbers = (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, '') };
    
    const [pesquisaPor, setPesquisaPor] = React.useState("NOME");
    const optionsPesquisaPor = [
        { value: 'NOME', label: 'Nome' },
        { value: 'EMAIL', label: 'E-Mail' },
        { value: 'CPF', label: 'CPF' },
    ];
    const handlePesquisaPorChange = (value) => {
        setValue("idcliente", '');
        setValue("nomecliente", '');
        setValue("cpfcliente", '');
        setValue("celularcliente", '');
        setValue("emailcliente", '');
        setPesquisaPor(value);
    }

    const enableFields = () => {
        setdisabledEmail(false);
        setdisabledNome(false);
        setdisabledCPF(false);
        setdisabledCelular(false);
    }

    const [searchForName, setSearchForName] = React.useState([]);
    const handleNameChange = (e) => {
        if (e !== null) {
            const nameContains = e.target.value;
            if (((nameContains !== null && nameContains !== undefined)) && nameContains.length >= 5) {
                const endPoint = "clientes/clientebyNomebyEstabelecimento/" + nameContains + "/" + session.estabelecimentoId;
                UseGetApiSimple(endPoint, 0).then(result => {
                    setSearchForName(result.data);
                });
                
            } else {
                setSearchForName([]);
                enableFields();
            }
        }
    }

    const [searchForCPFChange, setSearchForCPFChange] = React.useState([]);
    const handleCPFSeachChange = (e) => {
        if (e !== null) {
            const cpfContains = e.target.value;
            
            if (((cpfContains !== null && cpfContains !== undefined)) && cpfContains.length >= 5) {
                const endPoint = "clientes/clientebyContaisCpfEstabelecimento/" + cpfContains + "/" + session.estabelecimentoId;
                UseGetApiSimple(endPoint, 0).then(result => {
                    setSearchForCPFChange(result.data);
                });
            } else {
                setSearchForCPFChange([]);
                enableFields();
            }
        }
    }

    const [searchForEmailChange, setSearchForEmailChange] = React.useState([]);
    const handleEmailSeachChange = (e) => {
        if (e !== null) {
            const emailContains = e.target.value;
            
            if (((emailContains !== null && emailContains !== undefined)) && emailContains.length >= 5) {
                const endPoint = "clientes/clientebyEmailbyEstabelecimento/" + emailContains + "/" + session.estabelecimentoId;
                UseGetApiSimple(endPoint, 0).then(result => {
                    setSearchForEmailChange(result.data);
                });
            } else {
                setSearchForEmailChange([]);
                enableFields();
            }
        }
    }

    const validateResult = (value) => {
        if (value !== null) {            
            setValue("idcliente", value.clienteId);
            setValue("nomecliente", value.nome);
            setValue("cpfcliente", value.cpf);
            setValue("emailcliente", value.email);
            setValue("celularcliente", value.celular);

            // Caso o CPF atual seja em branco, o campo fica aberto para edição
            if (value.cpf === '' && value.cpf !== null && value.cpf !== undefined) {
                setdisabledCPF(false);
            }
            else {
                setdisabledCPF(true);
            }

            // Caso o celular atual seja em branco, o campo fica aberto para edição
            if (value.celular === '' && value.celular !== null && value.celular !== undefined) {
                setdisabledCelular(false);
            }
            else {
                setdisabledCelular(true);
            }

            // Valida se o campo nome esta preenchido
            if (value.nome === '' && value.nome !== null && value.nome !== undefined) {
                setdisabledNome(false);
            }
            else {
                setdisabledNome(true);
            }

            // Valida se o campo e-mail esta preenchido
            if (value.email === '' && value.email !== null && value.email !== undefined) {
                setdisabledEmail(false);
            }
            else {
                setdisabledEmail(true);
            }
        }
        else {
            setValue("idcliente", '');
            setValue("nomecliente", '');
            setValue("cpfcliente", '');
            setValue("celularcliente", '');
            setValue("emailcliente", '');
        }
    }

    return (
        <CardBody>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {loading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <label>{t('label.loading')}...</label>
                        <CircularProgress />
                    </div>
                </div>
            }

            <form onSubmit={handleSubmit(onSubmit)}>
                <GridContainer>
                    <GridItem xs={12} sm={6} md={6}>
                        <h3 style={{ marginTop: '5px', marginBottom: '3px' }}>{t('agenda.new_schedule')}</h3>
                        <label>{t('agenda.please_enter_data')}.</label>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                        <br />
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.data ? true : false}
                                label={t('label.date') + " *"}
                                variant="outlined"
                                inputRef={register({ required: t('label.required') })}
                                name="data"
                                defaultValue={intialValues.data}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskDate,
                                }}
                            />
                            {errors.data && <FormHelperText className={classes.labelRootError}>
                                <span>{errors.data.message}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={3} md={3}>
                        <br />
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.hora ? true : false}
                                label={t('agenda.start_time') + " *"}
                                variant="outlined"
                                inputRef={register({ required: true })}
                                name="hora"
                                defaultValue={intialValues.hora}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskTime,
                                }}
                            />
                            {errors.hora && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
                
                <GridContainer>
                    <hr className="lineGray"/>

                    <GridItem xs={12} sm={3} md={3}>
                        <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.situacaoItem?"select__label select__label_error":"select__label"}>
                                {
                                    t('label.search_for')
                                } 
                            </label>
                            <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.pesquisaPor ? true : false)}
                                isSearchable={true}
                                name="Pesquisa por"
                                options={optionsPesquisaPor}
                                value={optionsPesquisaPor.filter(({value}) => value === pesquisaPor)}
                                onChange={(option) => handlePesquisaPorChange(option.value !== null ? option.value : "Nome") }
                                placeholder="Nome"
                                ref={() => register({ name: "Pesquisa por" })}
                            />
                        </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={9} md={9}>

                        <FormControl fullWidth className={classes.formControl}>
                            {
                                pesquisaPor === "NOME" ? 
                                <>
                                    <label className={errors.situacaoItem?"select__label select__label_error":"select__label"}>
                                        {
                                            t('label.client_name')
                                        } 
                                    </label>
                                    <Autocomplete
                                        name="searchByName"
                                        noOptionsText="Digite os primeiros 5 caracteres para iniciar a busca"
                                        options={searchForName}
                                        getOptionLabel={(option) => {
                                            return option.nome;
                                        }}
                                        getOptionValue={({ clienteId }) => clienteId}
                                        onChange={(event, value) => {
                                            validateResult(value);
                                        }}
                                        onInputChange={handleNameChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </>
                                : 
                                pesquisaPor === "CPF" ?
                                <>
                                    <label className={errors.situacaoItem?"select__label select__label_error":"select__label"}>
                                        {
                                            t('label.client_cpf')
                                        } 
                                    </label>
                                    <Autocomplete
                                        name="searchByCPF"
                                        noOptionsText="Digite os primeiros 5 caracteres para iniciar a busca (apenas números)"
                                        options={searchForCPFChange}
                                        getOptionLabel={(option) => { 
                                            var rCpf = option.cpf.replace(/[.-]/g, '');
                                            return rCpf;
                                        }}
                                        getOptionValue={({ clienteId }) => clienteId}
                                        onChange={(event, value) => {
                                            validateResult(value);
                                        }}
                                        onInputChange={handleCPFSeachChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </>
                                :
                                pesquisaPor === "EMAIL" ?
                                <>
                                    <label className={errors.situacaoItem?"select__label select__label_error":"select__label"}>
                                        {
                                            t('label.client_email')
                                        } 
                                    </label>
                                    <Autocomplete
                                        name="searchByEmail"
                                        noOptionsText="Digite os primeiros 5 caracteres para iniciar a busca"
                                        options={searchForEmailChange}
                                        getOptionLabel={(option) => {
                                            return option.email;
                                        }}
                                        getOptionValue={({ clienteId }) => clienteId}
                                        onChange={(event, value) => {
                                            validateResult(value);
                                        }}
                                        onInputChange={handleEmailSeachChange}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </>
                                :
                                <></>
                            }

                        </FormControl>
                    </GridItem>
                    
                    <hr className="lineGray"/>
                </GridContainer>
                
                <GridContainer>
                    <input className={classes.hidden} defaultValue={intialValues.idcliente} name="idcliente" ref={register} />
                    <GridItem xs={12} sm={4} md={4}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.cpf ? true : false}
                                label="CPF"
                                variant="outlined"
                                onBlur={handleCPFChange}
                                inputRef={register({ required: false })}
                                name="cpfcliente"
                                defaultValue={intialValues.cpf}
                                disabled={disabledCPF}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    inputComponent: MaskCPF,
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {loadingValidateCPF && <LoadingIcon className="rotate" />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {   
                                errors.cpf &&
                                <FormHelperText className={classes.labelRootError}>
                                    <span>{errors.cpf.message} </span>
                                </FormHelperText>
                            }
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={8} md={8}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.emailcliente ? true : false}
                                label={t('label.client_email') + " *"}
                                variant="outlined"
                                onBlur={handleEmailChange}
                                inputRef={register({
                                    required: t('label.required'),
                                    pattern: {
                                        value: /^\S+@\S+$/i,
                                        message: t('label.invalid_email')
                                    },
                                    maxLength: {
                                        value: 50,
                                        message: t('label.enter_a_maximum_of_50_characters')
                                    }
                                })}
                                name="emailcliente"
                                defaultValue={intialValues.cliente}
                                disabled={disabledEmail}
                                InputLabelProps={{ shrink: true }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            {loadingValidateEmail && <LoadingIcon className="rotate" />}
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            {errors.emailcliente && <FormHelperText className={classes.labelRootError}>
                                <span> {errors.emailcliente.message} </span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.nomecliente ? true : false}
                                isSearchable={true}
                                label={t('label.client_name') + " *"}
                                variant="outlined"
                                inputRef={register({ required: true })}
                                name="nomecliente"
                                defaultValue={intialValues.nomecliente}
                                disabled={disabledNome}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 100 }}
                            />
                            {
                                errors.nomecliente && 
                                <FormHelperText className={classes.labelRootError}>
                                    <span>{t('label.required')}</span>
                                </FormHelperText>
                            }
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={4} md={4}>
                        <FormControl fullWidth className={classes.formControl}>
                            {
                                celularObrigatorio ?
                                <>
                                    <TextField
                                        error={errors.celularcliente ? true : false}
                                        label={t('label.cell_phone') + " *"}
                                        variant="outlined"
                                        inputRef={register({ required: true })}
                                        name="celularcliente"
                                        defaultValue={intialValues.celularcliente}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ inputComponent: MaskCel }}
                                        disabled={disabledCelular}
                                    />
                                    {
                                        errors.celularcliente && 
                                        <FormHelperText className={classes.labelRootError}>
                                            <span>{t('label.required')}</span>
                                        </FormHelperText>
                                    }
                                </>
                                :
                                <TextField
                                    error={errors.celularcliente ? true : false}
                                    label={t('label.cell_phone')}
                                    variant="outlined"
                                    inputRef={register({ required: false })}
                                    name="celularcliente"
                                    defaultValue={intialValues.celularcliente}
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ inputComponent: MaskCel }}
                                    disabled={disabledCelular}
                                />
                            }
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={5} md={5}>
                        <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.profissional ? "select__label select__label_error" : "select__label"}>
                                {t('label.professional')} *</label>
                            <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.profissional ? true : false)}
                                isSearchable={true}
                                name="profissional"
                                placeholder="Selecione..."
                                options={listSelectProfissional}
                                value={listSelectProfissional.filter(({ id }) => id === profissional)}
                                getOptionLabel={({ title }) => title}
                                getOptionValue={({ id }) => id}
                                onChange={(value) => handleProfissionalChange(value.id !== null ? value.id : "")}

                                ref={() => register(
                                    { name: "profissional" },
                                    { required: true })
                                }
                            />
                            {errors.profissional && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={5} md={5}>
                        <FormControl fullWidth className={classes.formControl}>
                            <label className={errors.servico ? "select__label select__label_error" : "select__label"}>
                                {t('label.service')}  *</label>
                            <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.servico ? true : false)}
                                isSearchable={true}
                                name="servico"
                                placeholder="Selecione..."
                                options={listSelectServico}
                                value={listSelectServico.filter(({ servicoId }) => servicoId === servico)}
                                getOptionLabel={({ descricao }) => descricao}
                                getOptionValue={({ servicoId }) => servicoId}
                                onChange={(value) => handleServicoChange(value.servicoId !== null ? value.servicoId : "")}
                                ref={() => register(
                                    { name: "servico" },
                                    { required: true })
                                }
                            />
                            {errors.servico && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                    <GridItem xs={12} sm={2} md={2}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.duracao ? true : false}
                                label={t('label.duration_minutes') + " *"}
                                variant="outlined"
                                name="duracao"
                                inputRef={register({ required: true })}
                                defaultValue={intialValues.duracao}
                                InputLabelProps={{ shrink: true }}
                                inputProps={{ maxLength: 3 }}
                                onInput={(e) => onlyNumbers(e)}
                            />
                            {errors.duracao && <FormHelperText className={classes.labelRootError}>
                                <span>{t('label.required')}</span>
                            </FormHelperText>}
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <FormControl fullWidth className={classes.formControl}>
                            <TextField
                                error={errors.obs ? true : false}
                                label={t('label.obs') + " *"}
                                variant="outlined"
                                inputRef={register}
                                name="obs"
                                defaultValue={intialValues.obs}
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rowsMax="3"
                                rows="2"
                                inputProps={{ maxLength: 500 }}
                            />
                        </FormControl>
                    </GridItem>
                </GridContainer>
                <GridContainer justify="center">
                    <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                        <div className={classes.textCenter}>
                            <Button onClick={hideModal} color="transparent" className={classes.updateProfileButton}>
                                {t('button.cancel')}
                            </Button>
                            <Button type="submit" color="primary" className={classes.updateProfileButton}>
                                {t('button.to_save')}  {loading && <div> ... {t('label.loading')}</div>}
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
            </form>
        </CardBody>
    );
}
